import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pay-info-confirm" }

import { ref, computed } from 'vue';

import { XrkTable, XrkTableProps } from 'xrk-components';

import { prohibitList } from '../data-source/apis';
import {
  indexCol,
  entpNameCol,
  individualNameCol,
  operatorCol,
  phoneCol,
  parkNameCol,
  projectNameCol,
  settlementTaskCountCol,
  taskPriceCol,
  projectPayPriceCol,
  orderPriceCol
} from '../fields/columns';

export default /*#__PURE__*/_defineComponent({
  __name: 'prohibit-list',
  props: {
    done: { default: () => ({}) },
    prohibitInterceptCacheKey: { default: '' }
  },
  setup(__props: any) {

const props = __props;
// 搜索项
const searchConfig = ref<XrkTableProps['searchConfig']>({
  searchBtn: {
    show: false,
    text: '搜索'
  },
  resetBtn: {
    show: false,
    text: '重置'
  },
  searchColumns: [],
  otherComponents: []
});

// 列表
const tableConfig = computed<XrkTableProps['tableConfig']>(() => {
  return {
    tableColumns: [
      indexCol,
      entpNameCol,
      individualNameCol,
      operatorCol,
      phoneCol,
      parkNameCol,
      projectNameCol,
      settlementTaskCountCol,
      taskPriceCol,
      projectPayPriceCol,
      orderPriceCol,
      {
        label: '提示原因',
        prop: 'prohibitInterceptErrorMsgList',
        formatter: ({ cellValue }) => cellValue.join('\n')
      }
    ].filter(Boolean)
  };
});

const getListAjax = async params => {
  const reqData = {
    ...params,
    prohibitInterceptCacheKey: props.prohibitInterceptCacheKey
  };
  const data = await prohibitList(reqData);
  return data;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(XrkTable), {
      ref: "xrkTableRef",
      getListAjax: getListAjax,
      searchConfig: searchConfig.value,
      tableConfig: tableConfig.value
    }, null, 8, ["searchConfig", "tableConfig"])
  ]))
}
}

})